import api from '../api/api';

const getPlaylistsByCourseId = async (courseId) => {
  try {
    const response = await api.get(`/playlists/course/${courseId}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

const getPlaylistById = async (playlistId) => {
  try {
    const response = await api.get(`/playlists/${playlistId}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

const playlistService = {
  getPlaylistsByCourseId,
  getPlaylistById,
};

export default playlistService;
